import * as React from 'react';

export interface ShapeProps {
  width: number;
}

const defaultProps = {
  viewBox: '0 0 32 32',
  fill: 'none'
};

//              ,,
//             `&M`
//            .*&&*.
//            f&&&&u
// '|r/1-+I;"/&&&&&&),:!>]1/r/'
//   !M&&&&&&&&&&&&&&&&&&&&&I
//    '/&&&&&&&&&&&&&&&&&&/'
//      IM&&&&&&&&&&&&&&MI
//      IM&&&&&&&&&&&&&&MI
//    '/&&&&&&&&&&&&&&&&&&/'
//   I&&&&&&&&&&&&&&&&&&&&&M!
// '|r/1]>!:,)&&&&&&/":I+-1/r|'
//            u&&&&f
//            .*&&*.
//             `M&`
//              ,,

// Shape 88 in figma
export const Shape1 = ({ ...props }: ShapeProps) => (
  <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M137.5 43.75V81.25C137.5 83.6937 136.075 85.9062 133.863 86.925C133.025 87.3125 132.138 87.5 131.25 87.5C129.788 87.5 128.338 86.9875 127.188 85.9937L112.5 73.4062V84.375C112.5 93.0062 105.506 100 96.875 100H93.75V118.75C93.75 121.025 92.5125 123.125 90.5125 124.225C89.575 124.744 88.5375 125 87.5 125C86.3375 125 85.1813 124.675 84.1625 124.038L54.475 105.288C52.6313 104.119 51.6 102.106 51.6 100H50C45.3875 100 41.4 97.4688 39.2313 93.75H12.5V81.25H18.75C31.25 81.25 36.0375 79.8812 43.75 56.25C46.425 48.05 49.7688 27.6875 81.25 25.2438V25H96.875C105.506 25 112.5 31.9937 112.5 40.625V51.5938L127.188 39.0063C129.038 37.4188 131.644 37.05 133.863 38.075C136.075 39.0938 137.5 41.3062 137.5 43.75Z" fill="#EF6C00"/>
    <path opacity="0.4" d="M100 25.3375V99.65C98.9875 99.8563 97.95 100 96.875 100H93.75V109.375H60.95L54.475 105.288C52.6313 104.119 51.6 102.106 51.6 100H71.875V26.6937C74.6875 26.025 77.7813 25.5187 81.25 25.25V100H90.625V25H96.875C97.95 25 98.9875 25.1312 100 25.3375ZM121.875 43.5562L112.5 51.5938V73.4062L121.875 81.4438V43.5562Z" fill="white"/>
    <path opacity="0.3" d="M57.8125 71.875C57.8125 74.4625 55.7125 76.5625 53.125 76.5625C50.5375 76.5625 48.4375 74.4625 48.4375 71.875C48.4375 69.2875 50.5375 67.1875 53.125 67.1875C55.7125 67.1875 57.8125 69.2875 57.8125 71.875ZM131.25 87.5C132.137 87.5 133.025 87.3125 133.862 86.925C136.075 85.9062 137.5 83.6937 137.5 81.25V43.75C137.5 41.3062 136.075 39.0937 133.862 38.0687C131.644 37.0437 129.038 37.4125 127.188 39L121.875 43.5562V81.4438L127.188 85.9937C128.338 86.9875 129.787 87.5 131.25 87.5Z" fill="black"/>
  </svg>
);

//                ``
//        .       nc       .
//        {t`    ,$$,    `\(
//         *$8!. *$$* .!M$*
//         'B$$$*$$$$*$$$B'
//  ';,,,"^^[$$$$$$$$$$$$[^^^,,;;'
//    ;f$$$$$$$$$$$$$$$$$$$$$$f;.
//       ;f$$$$$$$$$$$$$$$$f,.
//      .,\B$$$$$$$$$$$$$$$t;
//   .,t$$$$$$$$$$$$$$$$$$$$$$t;
//  ';;,,^^^[$$$$$$$$$$$$[^^",,,;'
//         '8$$$c$$$$*$$$B`
//         *$M<. *$$M .!M$*
//        [\`    ,$$,    `\\
//        .       nn       .
//                ``

// Shape 87 in figma
export const Shape2 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M129 96L120 78V90V108H108V88.8L90 87L66 93V108H54V93L39.69 85.848L27 96L12 87V60C12 53.37 17.37 48 24 48H36L53.106 38.202C53.64 37.824 54.216 37.512 54.816 37.224L54.966 37.14H54.978C56.508 36.426 58.2 36 60 36C61.098 36 62.136 36.192 63.144 36.468L63.186 36.462L105 48C105 48 129 55.032 129 66C129 76.968 129 96 129 96Z" fill="#6D4C41"/>
    <path opacity="0.4" d="M36 66V57C42.39 57 45 54.39 45 48H54C54 59.442 47.442 66 36 66Z" fill="white"/>
    <path opacity="0.3" d="M63.186 36.468L63.144 36.474C62.136 36.192 61.098 36 60 36C58.2 36 56.508 36.426 54.972 37.134H54.96L54.816 37.224C54.222 37.512 53.646 37.824 53.106 38.202L36 48H24C17.37 48 12 53.37 12 60H15.69C28.944 60 39.69 70.746 39.69 84C39.69 84.69 39.546 85.332 39.486 86.01L39.69 85.848L54 93L66 99V93V84C66 64.116 82.116 48 102 48C103.212 48 104.406 48.066 105.582 48.18C105.24 48.072 105 48 105 48L63.186 36.468ZM36 66V57C42.39 57 45 54.39 45 48H54C54 59.442 47.442 66 36 66ZM129 66C129 76.98 129 96 129 96L120 78V54.6C124.86 57.54 129 61.38 129 66Z" fill="black"/>
  </svg>
);


//               +B8<
//              [$$$$[
//             [$$$$$$\
//            ($$$$$$$$\
//           ($$$$$$$$$$\
//       `!tB$$$$$$$$$$$$8t!'
//   '!tB$$$$$$$$$$$$$$$$$$$$8(;'
// <8$$$$$$$$$$$$$$$$$$$$$$$$$$$$8?
// ?8$$$$$$$$$$$$$$$$$$$$$$$$$$$$8<
//   ';(8$$$$$$$$$$$$$$$$$$$$BfI'
//       '!f8$$$$$$$$$$$$Bf!`
//           \$$$$$$$$$$(
//            \$$$$$$$${
//             \$$$$$$[
//              [$$$$[
//               <8B+

// Shape 86 in figma
export const Shape3 = ({ ...props }: ShapeProps) => (
  <svg width="145" height="150" viewBox="0 0 145 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M60.4167 125H48.3333V106.25H60.4167V125ZM45.8502 36.525L12.0833 53.125L36.25 72.2687L45.8502 36.525Z" fill="#FBC02D"/>
    <path d="M103.198 90.3688L132.917 118.75H108.75L93.1867 102.65C85.9004 108.8 76.5963 112.5 66.4583 112.5C43.1013 112.5 24.1667 92.9125 24.1667 68.75C24.1667 48.9312 36.9085 30.1187 54.375 23.9812V43.75L103.198 90.3688Z" fill="#BF360C"/>
    <path opacity="0.3" d="M100.678 87.9688C96.0081 91.025 90.5163 92.8625 84.5833 92.8625C67.8962 92.8625 54.375 78.875 54.375 61.6125V43.75L100.678 87.9688Z" fill="black"/>
    <path opacity="0.5" d="M48.3333 59.375C48.3333 68.0062 41.5727 75 33.2292 75C29.9183 75 26.8794 73.8687 24.3902 72C24.3117 70.9187 24.1667 69.8562 24.1667 68.75C24.1667 59.9125 26.7404 51.1375 31.1206 43.7625C31.8094 43.6687 32.5163 43.75 33.2292 43.75C41.5727 43.75 48.3333 50.7437 48.3333 59.375Z" fill="black"/>
  </svg>
);

//           .   ,\(,   .
//         ,B$$*B$$$$BM$$B,
//     ';<[$$$$$$$$$$$$$$$$(<,`
//     $$$$$$$$$$$$$$$$$$$$$$$B
//    I$$$$$$$$$$$$$$$$$$$$$$$$,
//  +B$$$$$$$$$$$$$$$$$$$$$$$$$$8[
//  ?$$$$$$$$$$$$$$$$$$$$$$$$$$$$?
//  "$$$$$$$$$$$$$$$$$$$$$$$$$$$$"
// ^$$$$$$$$$$$$$$$$$$$$$$$$$$$$$B^
// .($$$$$$$$$$$$$$$$$$$$$$$$$$$$(.
//   +$$$$$$$$$$$$$$$$$$$$$$$$$$+
//   ($$$$$$$$$$$$$$$$$$$$$$$$$$(
//   .,?M$$$$$$$$$$$$$$$$$$$$M[,
//      .B$$$$$$$$$$$$$$$$$$8.
//       '?++f$$$$$$$$$$f+++`
//            `(f!`^+r\`

// Shape 85 in figma
export const Shape4 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M138 126C138 129.318 135.318 132 132 132H108C104.682 132 102 129.318 102 126C102 118.188 107.034 111.588 114 109.104V108C114 98.076 105.924 90 96 90C86.916 90 78.21 90 78 90C70.518 90 62.22 89.85 54 88.578V108C45.048 108 36.624 98.124 36.102 83.442C19.812 75.954 6.918 59.952 6.198 25.782C6.174 24.774 6 21.582 6 21C6 16.032 10.032 12 15 12C16.56 12 18.012 12.432 19.29 13.134C19.752 13.386 111.384 74.382 111.384 74.382C126.138 83.418 126.642 93.342 126.246 109.182C133.092 111.738 138 118.278 138 126Z" fill="#0097A7"/>
    <path opacity="0.4" d="M94.128 90C85.044 90 78.21 90 78 90C70.518 90 62.22 89.85 54 88.578C54 88.578 43.122 86.622 36.102 83.442C19.914 76.002 7.044 60.696 6.198 25.782L94.128 90Z" fill="white"/>
    <path opacity="0.3" d="M36.102 83.442C43.128 86.628 54 88.578 54 88.578V108C45.048 108 36.624 98.124 36.102 83.442ZM7.86 15.576C6.708 17.088 6 18.954 6 21C6 21.582 6.066 22.146 6.174 22.698C6.174 22.704 6.168 22.71 6.168 22.716C6.168 23.73 6.18 24.798 6.198 25.782L32.838 45.126L38.172 37.878L7.86 15.576ZM138 126C138 129.318 135.318 132 132 132H108C104.682 132 102 129.318 102 126C102 118.188 107.034 111.588 114 109.104L126.252 109.182C133.092 111.738 138 118.278 138 126Z" fill="black"/>
  </svg>
);

//            .I  II  !.
//         1I .$! cr ;$  ![
//      +I .*n`8$[$$[$B`rM..I+
//   ''  +$\r$$$$$$$$$$$$\\B+  `.
//    ;nn+n$$$$$$$$$$$$$$$$c[rr;
//  II,"?$$$$$$$$$$$$$$$$$$$$+^,I;
//   ';($$$$$$$$$$$$$$$$$$$$$$\;'
// ^+\n*$$$$$$$$$$$$$$$$$$$$$$*n\?"
//    "($$$$$$$$$$$$$$$$$$$$$$\`
// `+({[M$$$$$$$$$$$$$$$$$$$$*[[(+^
//   .Ir$B$$$$$$$$$$$$$$$$$$B$t;
//  'I^'`r$$$$$$$$$$$$$$$$$$r`'";'
//     <r!`n$B$$$$$$$$$$$$n'!r<
//        (f`"$rf$**$\r$,`f\
//       '`  r[ ;$`'$; {r  ``
//           "  "+  ?"  ,

// Shape 84 in figma
export const Shape5 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132 69C132 82.992 125.616 95.49 115.596 103.746C105.9 113.508 92.682 120 78 120C54.186 120 44.964 113.358 37.83 106.29C37.794 106.254 37.752 106.218 37.716 106.182C37.698 106.164 37.674 106.146 37.656 106.122L37.662 106.104C36.648 105.03 36 103.596 36 102C36 98.688 38.688 96 42 96H54.876C50.394 88.476 48 79.146 48 69C48 67.968 48.06 66.96 48.108 65.946L48 66C30 66 18 42 18 30C18 26.688 20.688 24 24 24C24 24 85.938 24 87 24C110.868 24 130.344 42.594 131.85 66.084C131.85 66.084 132 68.472 132 69Z" fill="#8D6E63"/>
    <path opacity="0.3" d="M40.5 39C40.5 36.516 42.516 34.5 45 34.5C47.484 34.5 49.5 36.516 49.5 39C49.5 41.484 47.484 43.5 45 43.5C42.516 43.5 40.5 41.484 40.5 39ZM84 96C84.042 92.922 85.11 78 102 78V66C78.27 66 72 85.626 72 96H42C38.7 96 36 98.7 36 102C36 103.614 36.66 105 37.68 106.08V106.146C37.68 106.146 37.68 106.146 37.74 106.206L37.8 106.266C44.94 113.34 54.18 120 78 120C92.7 120 105.9 113.52 115.614 103.74C118.38 101.46 120.834 98.88 123 96H84ZM24 24C20.7 24 18 26.7 18 30C18 31.68 18.24 33.6 18.72 35.64C19.44 35.88 20.22 36 21 36C25.98 36 30 31.98 30 27C30 25.92 29.82 24.96 29.46 24C26.1 24 24 24 24 24Z" fill="black"/>
  </svg>

);

//             ^(*B$*(^
//           .t$$$$$$$$f.
//     .`^"I\B$$$$$$$$$$B(;"^`
//   `t$$$$$$$$$$$$$$$$$$$$$$$$t`
//  `$$$$$$$$$$$$$$$$$$$$$$$$$$$$`
//  I$$$$$$$$$$$$$$$$$$$$$$$$$$$$+
//  .*$$$$$$$$$$$$$$$$$$$$$$$$$$*.
//   '$$$$$$$$$$$$$$$$$$$$$$$$$$`
//   '$$$$$$$$$$$$$$$$$$$$$$$$$$`
//  .*$$$$$$$$$$$$$$$$$$$$$$$$$$*.
//  i$$$$$$$$$$$$$$$$$$$$$$$$$$$$+
//  `$$$$$$$$$$$$$$$$$$$$$$$$$$$$`
//   'f$$$$$$$$$$$$$$$$$$$$$$$$r`
//      `^";(B$$$$$$$$$$B\I"^`.
//           .($$$$$$$$f.
//             `(*$$*(^

// Shape 83 in figma
export const Shape6 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="150" viewBox="0 0 144 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132 78.125C132 86.7563 125.286 93.75 117 93.75C116.412 93.75 113.88 93.375 113.508 93.2813L97.17 90.0813C105.534 100.381 109.95 108.263 106.746 111.369C103.572 114.45 96.186 109.975 86.544 101.444L89.7 118.75C89.898 119.763 90 120.806 90 121.875C90 130.506 83.286 137.5 75 137.5C66.714 137.5 60 130.506 60 121.875C60 120.1 60.348 118.419 60.87 116.825L66.738 97.9938C66.738 97.9938 52.608 111.706 52.29 112.006L50.886 113.213C46.782 116.625 41.658 118.75 36 118.75C22.746 118.75 12 107.556 12 93.75C12 79.9438 22.746 68.75 36 68.75H54.402C41.412 54.2188 33.186 42.5813 37.254 38.6313C41.31 34.6938 52.242 43.0938 66 56.5563V37.5C66 23.6938 76.746 12.5 90 12.5C103.254 12.5 114 23.6938 114 37.5C114 44.7375 111.006 51.2 106.29 55.7625L89.166 71.2188C89.166 71.2188 112.938 63.0375 114 62.8125H114.006C114.006 62.8125 115.98 62.5 117.006 62.5C125.286 62.5 132 69.4938 132 78.125Z" fill="#F9A825"/>
    <path opacity="0.3" d="M78 68.75C97.188 88.8375 111.93 106.338 106.746 111.369C101.562 116.4 85.188 101.338 66 81.25C46.812 61.1625 32.07 43.6625 37.254 38.6313C42.438 33.6 58.812 48.6625 78 68.75Z" fill="black"/>
  </svg>

);

//               .$$.
//               .$$.
//     !M!       .$$.       !M!
//      !88!     .$$.     !88!
//        !88!   .$$.   !88!
//          !88! .$$. !88!
//            !88?$$?88!
// ++++++++++++[B$$$$B[++++++++++++
// ++++++++++++[B$$$$B[++++++++++++
//            !88?$$?88!
//          !88! .$$. !88!
//        !88!   .$$.   !88!
//      !88!     .$$.     !88!
//     !M!       .$$.       !*;
//               .$$.
//               .$$.

// Shape 82 in figma
export const Shape7 = ({ ...props }: ShapeProps) => (
  <svg width="145" height="144" viewBox="0 0 145 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132.917 84V132H123.854V110.022L114.792 102.018V132H105.729V110.022L96.6425 102H81.5625V132H72.5V102H63.4375V132H54.375V100.896C50.1337 99.402 46.6658 96.402 44.5452 92.526C44.5392 92.532 44.509 92.568 44.509 92.568L32.039 70.434L20.7229 77.394L20.7048 77.376C19.9133 77.748 19.0554 78 18.125 78C14.79 78 12.0833 75.312 12.0833 72C12.0833 70.65 12.615 69.468 13.3702 68.466L13.3219 68.4L25.7375 48.108L25.7737 48.138C26.1483 47.478 26.5773 46.866 27.0667 46.296C26.4262 42.81 25.4415 33.06 32.3652 24.858C36.9508 19.44 39.2708 15.114 39.2708 12H48.3333C48.3333 19.14 43.1798 26.058 39.3071 30.642C36.4373 34.044 35.7485 38.016 35.7062 40.992C37.9537 37.632 42.1406 32.724 49.2456 29.016C56.3567 25.308 60.906 22.836 63.7819 12H73.074C69.5638 27.378 62.9844 32.01 53.4627 36.984C48.7019 39.468 45.7535 42.558 44.0135 44.874C45.1071 45.792 46.0194 46.89 46.7262 48.132L46.7625 48.102C49.5356 52.464 53.8735 64.998 60.4167 66H114.792C124.803 66 132.917 74.058 132.917 84Z" fill="#FFA000"/>
    <path opacity="0.5" d="M73.074 12C69.5637 27.378 62.9844 32.01 53.4627 36.984C48.7019 39.468 45.7535 42.558 44.0135 44.874C41.911 43.11 39.2225 42 36.25 42C36.0627 42 35.8875 42.036 35.7062 42.054C32.2323 42.21 29.1692 43.818 27.0667 46.29C26.4262 42.81 25.4415 33.06 32.3652 24.858C36.9508 19.44 39.2708 15.114 39.2708 12H48.3333C48.3333 19.14 43.1798 26.058 39.3071 30.642C36.4312 34.05 35.7727 37.998 35.7365 40.968C37.9658 37.614 42.1285 32.736 49.2456 29.016C56.3567 25.308 60.906 22.836 63.7819 12H73.074Z" fill="black"/>
    <path opacity="0.3" d="M96.6425 102H114.792V132H105.729V110.022L96.6425 102ZM60.4167 102C58.284 102 56.2721 101.568 54.375 100.896V132H63.4375V102H60.4167Z" fill="black"/>
    <path opacity="0.4" d="M114.701 102H102.708H90.625H81.5625V90H101.011L114.701 102ZM42.7387 63.858L32.039 70.44L44.509 92.574L44.5452 92.532C46.6658 96.408 50.1337 99.402 54.375 100.896C56.2721 101.568 58.284 102 60.4167 102H63.4375H72.5V90H60.4167C54.9731 89.166 46.9015 72.102 42.7387 63.858Z" fill="white"/>
  </svg>

);

//          `!`  .$$.  '+^
//          !$*. .$$.  *$;
//     !M!   \$f .$$. r$[   !M!
//      !88!  *$?.$$.?$n  !88!
//  ,+".  !88!'M$<$$<$8'!88!  .,?,
//  ;(M$8(;,+88r$$$$$$f88<^!\*$*{;
//     .^+n8$*$$$$$$$$$$M$Bf<".
// +++++++++tB$$$$$$$$$$Br?++++++++
// ++++++++?rB$$$$$$$$$$Bf+++++++++
//     .,<tB$M$$$$$$$$$$*$8n+^.
//  ;{*$*\!^<88f$$$$$$r88+,;(8$M(;
//  ,+,.  !88!'8$<$$<$M'!88!  ."+,
//      !88!  n$?.$$.?$*  !88!
//     !M!   [$t .$$. f$\   !*;
//          ;$*  .$$. .*$!
//          ^+'  .$$.  `!`

// Shape 81 in figma
export const Shape8 = ({ ...props }: ShapeProps) => (
  <svg {...defaultProps} {...props}>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M17.1429 0H14.8571V10.1205L11.0659 0.736931L8.94666 1.59318L12.8361 11.2198L5.49442 3.87816L3.87818 5.49442L10.9148 12.5311L1.79586 8.5469L0.880734 10.6414L10.5297 14.8571H0V17.1429H10.5297L0.880738 21.3586L1.79586 23.4531L10.9148 19.469L3.87818 26.5056L5.49442 28.1218L12.8361 20.7802L8.94666 30.4069L11.0659 31.263L14.8571 21.8795V32H17.1429V21.8795L20.9341 31.263L23.0533 30.4069L19.164 20.7802L26.5056 28.1218L28.1218 26.5056L21.0851 19.469L30.2042 23.4531L31.1192 21.3586L21.4704 17.1429H32V14.8571H21.4702L31.1192 10.6414L30.2042 8.5469L21.0851 12.5311L28.1218 5.4944L26.5056 3.87816L19.164 11.2198L23.0533 1.59318L20.9341 0.736931L17.1429 10.1205V0Z"
          fill="currentColor" />
  </svg>
);

//               .88.
//               f$$f
//              \$$$$\
//            `n$$$$$$*`
//          .[$$$$$$$$$$('
//        `(B$$$$$$$$$$$$$t`
//     ^?*$$$$$$$$$$$$$$$$$$8+^
// I(*$$$$$$$$$$$$$$$$$$$$$$$$$$c{I
// ,[n$$$$$$$$$$$$$$$$$$$$$$$$$Br[;
//     `+8$$$$$$$$$$$$$$$$$$M?`
//        `\$$$$$$$$$$$$$$\`
//          .[$$$$$$$$$$('
//            'c$$$$$$*`
//              \$$$$f
//               \$$r
//               .88.

// Shape 80 in figma
export const Shape9 = ({ ...props }: ShapeProps) => (
  <svg width="149" height="150" viewBox="0 0 149 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M135.435 25.5L125.085 39.9C126.818 45.3688 130.375 57.95 130.375 68.75C130.375 93.875 118.834 105.581 99.3333 110.1V118.75C99.3333 121.275 97.8247 123.563 95.5028 124.525C94.733 124.85 93.9259 125 93.125 125C91.5108 125 89.9215 124.363 88.7357 123.169L78.076 112.438C76.884 112.463 75.7168 112.5 74.5 112.5H49.6667C46.5935 112.5 43.4521 112.244 40.3542 111.75V112.5C40.3542 122.831 47.2144 125 52.9757 125H62.0833C69.8748 125 76.3873 130.306 78.4299 137.5H68.1302C66.7085 135.65 64.5853 134.375 62.0833 134.375H52.9757C39.6526 134.375 31.0417 125.788 31.0417 112.5V109.463C21.6857 106.313 14.2109 100.85 12.963 93.75C12.4167 90.625 20.7607 75 49.6667 75H69.1732C71.9484 64.25 81.5899 56.25 93.125 56.25V68.75C88.5805 68.75 84.6382 71.25 82.4715 74.9313C92.9698 74.6563 102.009 72.9625 105.542 62.5C107.969 55.3188 110.179 44.9813 111.179 40.0063L100.649 25.725C98.6628 23.1688 98.9484 19.5 101.308 17.2938C105.858 13.0438 114.761 12.5813 118.38 12.5813C122.726 12.5813 130.648 13.225 134.808 17.5063C136.919 19.6688 137.179 23.0313 135.435 25.5Z" fill="#26A69A"/>
    <path opacity="0.3" d="M135.435 25.5L125.086 39.9L111.179 40.0125L100.65 25.7312C98.6629 23.175 98.9484 19.5062 101.308 17.3C105.858 13.05 114.761 12.5875 118.381 12.5875C122.726 12.5875 130.648 13.2312 134.808 17.5125C136.919 19.6687 137.179 23.0312 135.435 25.5ZM40.3542 79.6875C37.7839 79.6875 35.6979 81.7875 35.6979 84.375C35.6979 86.9625 37.7839 89.0625 40.3542 89.0625C42.9244 89.0625 45.0104 86.9625 45.0104 84.375C45.0104 81.7875 42.9244 79.6875 40.3542 79.6875ZM74.5 75C77.2193 75 79.8764 75 82.4715 74.9312C84.6382 71.25 88.5805 68.75 93.125 68.75V56.25C81.5899 56.25 71.9484 64.25 69.1733 75H74.5ZM49.6667 112.5H61.2266C66.0753 107.169 67.5156 100.15 67.5156 93.75H58.2031C58.2031 102.05 55.9433 110.519 40.0314 111.6C43.2411 112.131 46.4818 112.5 49.6667 112.5ZM78.076 112.437L88.7357 123.169C89.9215 124.362 91.5109 125 93.125 125C93.9259 125 94.733 124.85 95.5028 124.525C97.8247 123.562 99.3334 121.275 99.3334 118.75V110.1C93.0381 111.562 85.9172 112.275 78.076 112.437Z" fill="black"/>
    <path opacity="0.5" d="M130.375 68.75C130.375 103.212 108.733 112.5 74.5 112.5H61.2266C66.0753 107.169 67.5156 100.15 67.5156 93.75H74.5C88.1956 93.75 106.69 89.175 113.203 77.05C119.604 65.1375 118.828 40.0062 118.828 40.0062H125.123C126.867 45.5437 130.375 58.0312 130.375 68.75ZM40.3542 111.644V111.75C43.4521 112.244 46.5936 112.5 49.6667 112.5C46.5873 112.5 43.4583 112.144 40.3542 111.644ZM31.0417 93.75H12.963C14.2109 100.85 21.6857 106.312 31.0417 109.462V93.75ZM58.2031 93.75H40.3542V111.556C55.9371 110.375 58.2031 101.987 58.2031 93.75Z" fill="white"/>
  </svg>

);

//             `$$$$$$`
//      .+!    `$$$$$$`    !+.
//    .+B$$8!  `$$$$$$`  !8$$B+.
//   .M$$$$$$8!^$$$$$$^!8$$$$$$M.
//     !8$$$$$$B$$$$$$$$$$$$$8!
//       !8$$$$$$$$$$$$$$$$8!
// [[[[[[[($$$$$$$$$$$$$$$B([[[[[[[
// $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
// $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
// [[[[[[[(B$$$$$$$$$$$$$$$([[[[[[[
//       !8$$$$$$$$$$$$$$$$8!
//     !8$$$$$$$$$$$$$B$$$$$$8!
//   .M$$$$$$8!^$$$$$$^!8$$$$$$M.
//    .+B$$8!  `$$$$$$`  !8$$B+.
//      .+!    `$$$$$$`    !+.
//             `$$$$$$`

// Shape 79 in figma
export const Shape10 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132 65.982V108H120V98.484L114 92.484V108H102V98.484L92.946 89.43C88.14 88.932 82.98 88.104 78 87.042V108H66V102.012C66 101.256 65.868 91.722 62.538 82.656C61.644 82.314 60.798 81.972 60 81.618V108H48V102.012C47.994 100.542 47.616 66 24 66H18L12 54L24 48C24 48 30 36 36 36C36.15 36 36.372 36 36.552 36C37.788 32.514 41.088 30 45 30C48.912 30 52.212 32.514 53.448 36C66.252 36 84.102 36 102 36C118.56 36 131.988 49.422 132 65.982Z" fill="#6D4C41"/>
    <path opacity="0.3" d="M60 81.618V108H48V102.012C47.994 100.542 47.616 66 24 66V65.958C24 65.958 42 66 54 78C55.224 79.224 57.336 80.448 60 81.618ZM111.474 89.958C107.568 89.958 103.896 89.958 102 89.958C99.264 89.958 96.18 89.766 92.946 89.43L102 98.484V108H114V92.484L111.474 89.958Z" fill="black"/>
  </svg>
);

//             `{*$$*(`
//            ,$$$$$$$$,
//            +$$$$$$$$?
//             \$$$$$$f
//              `f$$f`
//   .`^`         ?(         `^`.
// 't$$$$$('     '[('     '\B$$$$t.
// M$$$$$$$$t"''($$$$('',\$$$$$$$$*
// *$$$$$$$$f,``($$$$f``,f$$$$$$$$*
// 'f$$$$B\'     `[\`     '($$$$$f'
//   .`^`         [[         `^`.
//              `t$$t`
//             \$$$$$$(
//            ?$$$$$$$$+
//            ,$$$$$$$$,
//             `(*$$*[`

// Shape 78 in figma
export const Shape11 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="150" viewBox="0 0 144 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M132 59.35V131.25H120V100L114 87.5V103.125C114 103.637 113.94 104.15 113.82 104.65L107.382 131.25H95.004L101.664 103.744L91.698 81.25H78V131.25H66V81.25H59.208L54.63 90.7812L65.478 116.206L54.516 121.287L41.364 90.4625L52.326 67.6313C40.326 64.3438 32.19 53.3 30.438 37.65L12 31.25V18.75H48V31.25C48 36.8875 49.17 50 60 50L75.186 29.05L75.252 29.0375C78.966 22.875 85.5 18.75 93 18.75C98.214 18.75 102.924 20.8 106.59 24.075L128.484 49.4C130.65 52.1125 132 55.55 132 59.35Z" fill="#8D6E63"/>
    <path opacity="0.3" d="M54.63 90.7812L65.478 116.206L54.516 121.288L41.364 90.4625L45.792 81.25H59.208L54.63 90.7812ZM111 81.25H91.698L101.664 103.744L95.004 131.25H107.382L113.82 104.65C113.94 104.15 114 103.638 114 103.125V87.5L111 81.25Z" fill="black"/>
  </svg>

);

//             ,t*$$M(,
//           .*$$$$$$$$*.
//           ($$$$$$$$$$(
//           [$$$$$$$$$${
//           .r$$$$$$$$r
//   ,[n**r+`  ,*$$$$n;  ^[rc*n{^
// '8$$$$$$$$M"  "BBI  ,M$$$$$$$$M`
// M$$$$$$$$$$$M<"fr^!*$$$$$$$$$$$*
// M$$$$$$$$$$$*!^ft^In$$$$$$$$$$$M
// `M$$$$$$$$M,  "8B,  ^n$$$$$$$$8'
//   ,(n*cr[`  ^n$$$$n;  `+r**n[,
//            t$$$$$$$$c.
//           {$$$$$$$$$$[
//           ($$$$$$$$$$(
//           .*$$$$$$$$*.
//             ;(M$$*f,

// Shape 77 in figma
export const Shape12 = ({ ...props }: ShapeProps) => (
  <svg width="144" height="150" viewBox="0 0 144 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M126 37.5V50C119.382 50 114 55.6063 114 62.5V112.5C114 126.288 103.236 137.5 90 137.5H36V62.5V56.25H24L18 43.75L28.044 29.975L28.056 30.0063C30.144 27.6688 32.88 25.975 36 25.3125V12.5C36 12.5 60 18.75 60 37.5C60 41.75 60.054 54.6688 60.09 62.5H66C79.254 62.5 90 73.6938 90 87.5V125C96.618 125 102 119.394 102 112.5V62.5C102 48.7125 112.764 37.5 126 37.5Z" fill="#BDBDBD"/>
    <path opacity="0.3" d="M102 62.5V112.5C102 119.375 96.6 125 90 125V137.5C90.114 137.5 90.36 137.5 90.6 137.438C91.56 137.375 93.426 137.063 95.946 136.688C106.32 133.938 114 124.188 114 112.5V62.5C114 55.625 119.4 50 126 50V37.5C112.74 37.5 102 48.6875 102 62.5ZM48 137.5H60C60 130.625 65.4 125 72 125V112.5C58.74 112.5 48 123.688 48 137.5Z" fill="black"/>
  </svg>

);
